import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { Chip, Dot } from '@frontend/design-system';
import { useGetAppointmentColorsEnabled } from '../../hooks';

interface Props extends Omit<React.ComponentProps<typeof Chip>, 'children'> {
  name: string;
  color?: string;
  maxWidth?: number;
  isArchived?: boolean;
}

export const AppointmentTypeChip = ({ name, color, maxWidth = 100, isArchived = false, ...restProps }: Props) => {
  const { canUseAppointmentColors } = useGetAppointmentColorsEnabled();

  return (
    <Chip
      key={name}
      css={{ maxWidth }}
      variant='default'
      leftElement={
        <>
          {canUseAppointmentColors && color && <Dot color='warning' css={[{ background: color }, dotStyle]} />}
          {isArchived && <Icon name='archive-small' color='subdued' />}
        </>
      }
      {...restProps}
    >
      {name}
    </Chip>
  );
};

const dotStyle = css({
  border: 'none',
  position: 'relative',
  minWidth: 8,
  width: 8,
  height: 8,
});
